document.addEventListener('DOMContentLoaded', function () {
  // Scroll progress + sticky CTA
  var progressBar = document.querySelector('.scroll-progress');
  var stickyCta = document.querySelector('.sticky-cta');
  window.addEventListener('scroll', function () {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var pct = max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0;
    if (progressBar) progressBar.style.width = pct + '%';
    if (stickyCta) stickyCta.classList.toggle('show', window.scrollY > 320);
  });

  // Scroll reveal
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); revealObserver.unobserve(en.target); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('[data-reveal]').forEach(function (el) { revealObserver.observe(el); });

  // Cursor cloud trail
  var lastSpawn = 0, lastPos = null;
  document.addEventListener('mousemove', function (e) {
    var now = Date.now();
    if (now - lastSpawn < 260) return;
    if (lastPos) {
      var dx = e.clientX - lastPos.x, dy = e.clientY - lastPos.y;
      if (Math.sqrt(dx * dx + dy * dy) < 70) return;
    }
    lastSpawn = now;
    lastPos = { x: e.clientX, y: e.clientY };
    var span = document.createElement('span');
    span.className = 'cloud-trail-item';
    span.textContent = '☁️';
    span.style.left = e.clientX + 'px';
    span.style.top = e.clientY + 'px';
    document.body.appendChild(span);
    setTimeout(function () { span.remove(); }, 1800);
  });

  // FAQ accordions
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('open');
      item.closest('.faq-list').querySelectorAll('.faq-item.open').forEach(function (o) { o.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

  // Background/looping videos: play only if a real src is set
  document.querySelectorAll('video[data-autoplay]').forEach(function (v) {
    var src = v.querySelector('source');
    if (src && src.getAttribute('src')) {
      v.muted = true; v.volume = 0;
      v.play().catch(function () {});
      if (v.hasAttribute('data-last-seconds')) {
        var secs = parseFloat(v.getAttribute('data-last-seconds'));
        var startAtEnd = function () {
          if (!v.duration) return;
          v.currentTime = Math.max(0, v.duration - secs);
          v.play().catch(function () {});
        };
        v.addEventListener('loadedmetadata', startAtEnd);
        v.addEventListener('timeupdate', function () {
          if (v.duration && v.currentTime >= v.duration - 0.3) startAtEnd();
        });
      }
    } else {
      v.closest('.video-bg-wrap') && v.closest('.video-bg-wrap').classList.add('no-video');
    }
  });

  function fmtTime(s) {
    if (!s || !isFinite(s)) return '0:00';
    var m = Math.floor(s / 60);
    var sec = Math.floor(s % 60).toString().padStart(2, '0');
    return m + ':' + sec;
  }

  function buildWaveform(container, barCount, audioEl) {
    container.innerHTML = '';
    var bars = [];
    for (var i = 0; i < barCount; i++) {
      var bar = document.createElement('div');
      bar.className = 'wave-bar';
      bar.style.height = '4px';
      bar.style.animationDelay = ((i % 20) * 60) + 'ms';
      container.appendChild(bar);
      bars.push(bar);
    }
    var AC = window.AudioContext || window.webkitAudioContext;
    if (AC && audioEl && audioEl.currentSrc) {
      fetch(audioEl.currentSrc).then(function (r) { return r.arrayBuffer(); }).then(function (buf) {
        var ctx = new AC();
        ctx.decodeAudioData(buf, function (decoded) {
          var data = decoded.getChannelData(0);
          var step = Math.floor(data.length / barCount);
          for (var i = 0; i < barCount; i++) {
            var max = 0, start = i * step;
            for (var j = 0; j < step; j++) { var v = Math.abs(data[start + j] || 0); if (v > max) max = v; }
            bars[i].style.height = Math.max(4, Math.round(max * (container.classList.contains('small') ? 32 : 40))) + 'px';
          }
        });
      }).catch(function () {});
    }
    return bars;
  }

  function wirePlayer(root) {
    var audio = root.querySelector('audio');
    var playBtn = root.querySelector('.play-btn');
    var waveform = root.querySelector('.waveform');
    var timeCur = root.querySelector('[data-time-current]');
    var timeDur = root.querySelector('[data-time-duration]');
    var iconPlay = playBtn ? playBtn.querySelector('.icon-play') : null;
    var iconPause = playBtn ? playBtn.querySelector('.icon-pause') : null;
    if (!audio || !waveform) return;
    var bars = buildWaveform(waveform, root.getAttribute('data-bars') || 60, audio);

    function updateActive() {
      var pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
      bars.forEach(function (b, i) {
        b.classList.toggle('active', (i / bars.length) * 100 <= pct);
      });
      if (timeCur) timeCur.textContent = fmtTime(audio.duration ? audio.duration - audio.currentTime : 0);
      if (timeDur) timeDur.textContent = fmtTime(audio.duration || 0);
    }
    audio.addEventListener('timeupdate', updateActive);
    audio.addEventListener('loadedmetadata', updateActive);
    audio.addEventListener('play', function () { if (iconPlay) iconPlay.style.display = 'none'; if (iconPause) iconPause.style.display = ''; });
    audio.addEventListener('pause', function () { if (iconPlay) iconPlay.style.display = ''; if (iconPause) iconPause.style.display = 'none'; });
    audio.addEventListener('ended', function () { audio.currentTime = 0; });

    if (playBtn) playBtn.addEventListener('click', function () {
      document.querySelectorAll('audio').forEach(function (a) { if (a !== audio) a.pause(); });
      if (audio.paused) audio.play(); else audio.pause();
    });
    waveform.addEventListener('click', function (e) {
      if (!audio.duration) return;
      var rect = waveform.getBoundingClientRect();
      var ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
      audio.currentTime = ratio * audio.duration;
    });
  }

  document.querySelectorAll('[data-player]').forEach(wirePlayer);
});
